import { useState , useEffect} from 'react';
import axios from 'axios';

export const useFetchFlowers = () => {
    const [flowerList, setFlowerList] = useState([]);
    const [isLoading , setIsLoading] = useState(false);
    //const [isError , setIsError] = useState(false);
    
    useEffect(() => {
        const fetchRequest = async ()  =>{
            setIsLoading(true);
            //setIsError(false);

            //JSON取得
            axios.get('/assets/json/flowerData.json?'+(new Date()).getTime())
                .then(res => {
                    const data = JSON.parse(JSON.stringify(res.data));
                    setFlowerList(data.list);
                })
                //.catch(() => setIsError(true))
                .finally(() => setIsLoading(false));
        }
        fetchRequest();
    }, []); 

    return {flowerList , isLoading };
}
